<div class="container-fluid dashboard pt-3">
  <div>
    <div>
      <v-loading-spinner [spinnerColor]="'#ffc220'" [spinnerText]="'Redirecting'"></v-loading-spinner>
    </div>
  </div>
</div>
